import Service from '@/utils/request';

/**
 *城管一张图首页相关接口
 */
const IndexApi = {
    /**
   * 获取网格列表
   * @param {appCode} params
   * @returns
   */
    fetchGridList: (params) => Service.get('/data/gridGroup/dailyGridList', { params: { ...params, appCode: 'CW' } }),
    /**
   * 获取网格组日常巡查任务列表
   * @param {startTime:开始时间,endTime：结束时间,gridGroupId:网格组id} params
   * @returns
   */
    fetchGridGroupTaskList: (params) => Service.get('/data/gridGroup/loadTaskData', { params: { ...params, appCode: 'CW' } }),

    /**
   * 获取网格统计信息
   * @param {startTime:开始时间,endTime：结束时间,gridGroupId:网格组id} params
   * @returns
   */
    fetchGridGroupStats: (params) => Service.get('/data/gridGroup/loadGridGroupData', { params: { ...params, appCode: 'CW' } }),

    /**
   * 获取日常巡查任务列表
   * @param {startTime:开始时间,endTime：结束时间} params
   * @returns
   */
    fetchDailyTaskList: (params) => Service.get('/data/gridGroup/dailyTaskList', { params: { ...params, appCode: 'CW' } }),

    /**
   * 获取正射地图列表
   *  @param {startTime:开始时间,endTime：结束时间} params
   * */
    fetchOrthoList: (params) => Service.get('/fcs/taskDataMap/listZs', { params: { ...params } }),

    /**
   * 获取照片列表
   *  @param {startTime:开始时间,endTime：结束时间} params
   * */
    taskDataPictureList: (params) => Service.get('/fcs/taskDataPicture/query', { params: { ...params } }),

    /*
   * 查询事件类型树结构
   *  @param {} params
   * */
    fetchEventTypeTree: (params) => Service.get('/data/eventType/tree', params),
    /**
   * 获取事件列表
   *  @param {startTime:开始时间,endTime：结束时间} params
   * */
    fetchEventList: (params) => Service.get('/data/eventInfo/list', {
        params: { ...params,
            appCode: 'CW',
        } }),

    /**
   * 服务数据统计
   *  @param {beginTime:开始时间,endTime：结束时间} params
   * */
    fetchServiceStatistics: (params) => Service.get('/fcs/statistics/countServiceData', {
        params: {
            ...params,
            appCode: 'CW',
        } }),
    /**
   * 服务项统计
   *  @param {beginTime:开始时间,endTime：结束时间} params
   * */
    fetchSubjectStatistics: (params) => Service.get('/fcs/statistics/countSubjectData', {
        params: {
            ...params,
            appCode: 'CW',
        } }),
    /**
   * 事件状态统计
   *  @param {startTime:开始时间,endTime：结束时间} params
   * */
    fetchEventStatusStatistics: (params) => Service.get('/workbench/suspectedEventStatusStatistics', {
        params: {
            ...params,
            appCode: 'CW',
        } }),
    /**
   * 事件类型统计
   *  @param {startTime:开始时间,endTime：结束时间} params
   * */
    fetchEventTypeStatistics: (params) => Service.get('/workbench/suspectedEventTypeStatistics', {
        params: {
            ...params,
            appCode: 'CW',
        } }),
};

export default {
    ...IndexApi,
};
